const timetableApi = {
  GETTIMETABLE: 'CSVPA-China/api/timeTable/getListAll', //课程表
  SAVETIMETABLE: 'CSVPA-China/api/timeTable/save', //保存课程表
  DELETETIMETABLE: 'CSVPA-China/api/timeTable/delete',
  exportTemplate: 'CSVPA-China/api/timeTable/exportTemplate', //下载模版
  importTimeTable: 'CSVPA-China/api/timeTable/importTimeTable' //导入课程表
}

export default timetableApi
